
import { Button, Card, CardActionArea, CardActions, CardContent, CardMedia, Grid } from '@mui/material';
import React from 'react';
import Consolas from '../../../fonts/Consolas';
import { BLANK, H5, H6, PARAGRAPH } from '../../../helper/constants';
import { ProjectCardProps } from './helper';
const ProjectCard = ({ description, image, link = BLANK, title, alt }: ProjectCardProps): JSX.Element =>
(
    <Grid item xs >
        <Card sx={{ maxWidth: 345 }} >
            <CardActionArea href={link} >
                <CardMedia
                    component="img"
                    height="240"
                    image={image}
                    alt={alt}/>
                <CardContent>
                    <Consolas as={H5}>{title}</Consolas>
                    <Consolas as={PARAGRAPH}>{description}</Consolas>
                </CardContent>
            </CardActionArea>
            <CardActions>
                <Button size="small"  color="info" variant='contained' href={link} target="_blank">
                    <Consolas as ={H6} color="white">See Project</Consolas>
                </Button>
            </CardActions>
        </Card>
    </Grid>
)

export default ProjectCard;
